var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('h2',[_vm._v("Listagem")]),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"sortOptions":{
                enabled: true,
                initialSortBy: { field: 'translatedName', type: 'asc' },
            }},on:{"on-row-click":_vm.onRowClick}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }